var React = require('react');

function DOH3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 22c-4.571-2.625-8-6.813-8-16l8-4 8 4c0 1.863-.14 3.52-.404 5H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7.7c-1.3 1.709-2.913 2.974-4.7 4zm6.5-9.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V15H18v1.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0V14h-1.5v-1.5zm3.5 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1H22v-1h-1.5a.5.5 0 0 1 0-1H22v-1h-1.5a.5.5 0 0 1-.5-.5zM13 17c1.105 0 2-1.12 2-2.5s-.895-2.5-2-2.5-2 1.12-2 2.5.895 2.5 2 2.5zm0-1c.552 0 1-.672 1-1.5s-.448-1.5-1-1.5-1 .672-1 1.5.448 1.5 1 1.5zm-6-4h1a2.5 2.5 0 0 1 0 5H7v-5zm1 1a1.5 1.5 0 0 1 0 3v-3z","fill":"#fff"}));
}

DOH3.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DOH3;

DOH3.default = DOH3;
